import React from 'react';
import PropTypes from 'prop-types';
import { FeatureDialog, LoadingOverlay } from '../../../../knock-design-system';
import { CreateProperty } from './CreateProperty';
import { ImportProperties } from './ImportProperties';
import { TransferProperty } from './TransferProperty';
import { propertyPropTypes } from '../prop-types';
import {
  PROPERTIES_DIALOG_MODES,
  PROPERTIES_DIALOG_TITLES,
  TABS,
} from '../constants';
import { PROPERTY_DETAILS } from '../properties-api/constants';

const getPropertyDetails = (currentProperty) =>
  currentProperty?.[TABS.OVERVIEW]?.[PROPERTY_DETAILS] || {};

const PropertiesDialog = ({
  closeDialog,
  currentProperty,
  dialogConfig,
  dialogMode,
}) => {
  const isOpen = Boolean(dialogMode);
  const { isOverlayOpen = false, primaryAction } =
    dialogConfig[dialogMode] || {};

  return (
    <FeatureDialog
      isOpen={isOpen}
      onClose={closeDialog}
      title={PROPERTIES_DIALOG_TITLES[dialogMode]}
    >
      <LoadingOverlay isInvisible isOpen={isOverlayOpen} zIndex={2} />

      {dialogMode === PROPERTIES_DIALOG_MODES.CREATE && (
        <CreateProperty
          closeDialog={closeDialog}
          createProperty={primaryAction}
        />
      )}

      {dialogMode === PROPERTIES_DIALOG_MODES.IMPORT && (
        <ImportProperties closeDialog={closeDialog} />
      )}

      {dialogMode === PROPERTIES_DIALOG_MODES.TRANSFER && (
        <TransferProperty
          closeDialog={closeDialog}
          propertyDetails={getPropertyDetails(currentProperty)}
          transferProperty={primaryAction}
        />
      )}
    </FeatureDialog>
  );
};

PropertiesDialog.propTypes = {
  closeDialog: PropTypes.func,
  currentProperty: propertyPropTypes,
  dialogMode: PropTypes.oneOf([
    PROPERTIES_DIALOG_MODES.CREATE,
    PROPERTIES_DIALOG_MODES.IMPORT,
    PROPERTIES_DIALOG_MODES.TRANSFER,
  ]),
  dialogConfig: PropTypes.shape({
    [PROPERTIES_DIALOG_MODES.CREATE]: PropTypes.shape({
      isOverlayOpen: PropTypes.bool,
      primaryAction: PropTypes.func,
    }),
  }),
};

export default PropertiesDialog;
